import React from 'react';
import { motion } from 'framer-motion';
import AnswerCard from './AnswerCard';
import FeedbackPanel from './FeedbackPanel';
import ProgressHeader from './ProgressHeader';

function QuestionScreen({
  question,
  currentIndex,
  total,
  selectedAnswer,
  onAnswer,
  onNext
}) {
  const answered = selectedAnswer !== null;
  const isCorrect = selectedAnswer === question.correctIndex;

  return (
    <div className="question-screen">
      <ProgressHeader current={currentIndex + 1} total={total} />
      <motion.div
        className="question-content"
        initial={{ opacity: 0, x: 18 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -18 }}
        transition={{ duration: 0.28 }}
      >
        <span className="question-eyebrow">{question.eyebrow}</span>
        <h1>{question.question}</h1>
        <div className="answer-list" aria-label="Antwoordmogelijkheden">
          {question.answers.map((answer, index) => (
            <AnswerCard
              key={answer}
              answer={answer}
              index={index}
              selected={selectedAnswer === index}
              correct={question.correctIndex === index}
              answered={answered}
              onSelect={onAnswer}
            />
          ))}
        </div>
        {answered && (
          <FeedbackPanel
            question={question}
            isCorrect={isCorrect}
            isLast={currentIndex === total - 1}
            onNext={onNext}
          />
        )}
      </motion.div>
    </div>
  );
}

export default QuestionScreen;